// Logout latch — set the moment the user clicks "Log out", before any state
// is torn down. useProfileSync consults it so the sync effect can never
// re-create the session in the window between the store reset and the Auth0
// redirect actually leaving the page (store user → null while isAuthenticated
// is still true looks exactly like a fresh login to the sync effect).
// Module-scoped: a real logout ends in a full page navigation, so the latch
// never needs resetting.

let loggingOut = false

export function beginLogout() {
  loggingOut = true
}

export function isLoggingOut(): boolean {
  return loggingOut
}
